// extracted by mini-css-extract-plugin
module.exports = {"md":"768px","lg":"1280px","card":"mf-N9","eyebrow":"mf-Oa","title":"mf-Ob","image":"mf-Oc","imagePlaceholder":"mf-Od","imagePlaceholderIcon":"mf-Oe","author":"mf-Of"};